"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { createContext, useSyncExternalStore } from "react";
const DrawerInsetContext = /*#__PURE__*/ createContext(null);
const ABOVE_MD_QUERY = '(min-width: 768px)';
function subscribeAboveMd(callback) {
    if (void 0 === globalThis.window) return ()=>{};
    const mql = globalThis.window.matchMedia(ABOVE_MD_QUERY);
    mql.addEventListener('change', callback);
    return ()=>mql.removeEventListener('change', callback);
}
function getAboveMdSnapshot() {
    return globalThis.window?.matchMedia(ABOVE_MD_QUERY).matches ?? false;
}
function getServerSnapshot() {
    return true;
}
function DrawerPortal({ inset, container, children, ...props }) {
    const isAboveMd = useSyncExternalStore(subscribeAboveMd, getAboveMdSnapshot, getServerSnapshot);
    const isInsetActive = inset ? isAboveMd : null;
    const insetContainer = isAboveMd ? container : void 0;
    const resolvedContainer = inset ? insetContainer : container;
    return /*#__PURE__*/ jsx(DrawerInsetContext.Provider, {
        value: isInsetActive,
        children: /*#__PURE__*/ jsx(Drawer.Portal, {
            container: resolvedContainer,
            ...props,
            children: children
        })
    });
}
export { DrawerInsetContext, DrawerPortal };
